import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromContact from './contact.reducer';

export const getContactState =
  createFeatureSelector<fromContact.ContactState>('contacts');

export const getContactPageState = createSelector(
  getContactState,
  (state) => state
);

export const stateGetIsLoading = (state: fromContact.ContactState) =>
  state.isLoading;
export const stateGetItems = (state: fromContact.ContactState) => state.data;
export const stateGetIsLoadingInteractions = (
  state: fromContact.ContactState
) => state.interactions.isLoading;
export const stateGetInteractionItems = (state: fromContact.ContactState) =>
  state.interactions.data;
export const stateGetFilteredItems = (state: fromContact.ContactState) =>
  state.filteredItems;
export const stateHasBeenFetched = (state: fromContact.ContactState) =>
  state.fetched;

export const getIsLoading = createSelector(
  getContactPageState,
  stateGetIsLoading
);

export const getError = createSelector(
  getContactPageState,
  (state) => state.error
);

export const getSuccess = createSelector(
  getContactPageState,
  (state) => state.success
);

export const getContactItems = createSelector(
  getContactPageState,
  stateGetItems
);

export const getIsLoadingInteractions = createSelector(
  getContactPageState,
  stateGetIsLoadingInteractions
);
export const getContactInteractionItems = createSelector(
  getContactPageState,
  stateGetInteractionItems
);
export const getContactInteractionError = createSelector(
  getContactPageState,
  (state) => state.interactions.error
);
export const getContactInteractionSuccess = createSelector(
  getContactPageState,
  (state) => state.interactions.success
);

export const getFilteredContactItems = createSelector(
  getContactPageState,
  stateGetFilteredItems
);

export const getContactById = createSelector(
  getContactPageState,
  (state) => state.data.filter((c) => +c.id === state.selectedId)[0]
);

export const fetched = createSelector(getContactPageState, stateHasBeenFetched);

export const interactionsFetched = createSelector(
  getContactPageState,
  (state) => state.interactions.fetched
);
